module.exports = __webpack_public_path__ + "static/partenaires-logo-monaco-explorations-574061c30771d4361b45fd9fad0c57ec.svg";